import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  type?:
    | 'type1'
    | 'type2'
    | 'type3'
    | 'type4'
    | 'type5'
    | 'type6'
    | 'type7'
    | 'type8' // 기본2
    | 'type9' // 기본3
    | 'type10' // 기본4
    | 'type11' // 기본5
    | 'type12'; // PC 구분선 박스형
  // type1: 기본, type2: square, type3: round, type4: text, type5: underBar, type6: round white, type7: underBar small, type8: 기본2, type9: 기본3, type10: 기본4, type11: 기본5
  children?: React.ReactNode;
}
const x = '\u00d7';
export const FoldMenuBar = styled.div<IProps>`
  .category-fold {
    display: inline-block;
    max-width: 100%;
  }

  .btn-folding {
    position: absolute;
    z-index: 1;

    &:after {
      content: '';
      position: absolute;
      top: -10%;
      right: 100%;
      width: 100%;
      height: 120%;
      background: linear-gradient(
        270deg,
        #fff 29.17%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  &.now-fold {
    .category-fold {
      padding-right: 60px;

      .swiper {
        padding-right: 30px;
      }
    }
  }

  ${props => {
    switch (props.type) {
      case 'type1':
        return css`
          .btn-folding {
            top: 0;
            right: 20px;
            width: 35px;
            height: 34px;
          }
        `;
      case 'type2':
        return css`
          .btn-folding {
            top: 12px;
            right: 20px;
            width: 28px;
            height: 28px;
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .btn-folding {
      right: ${mixin.pxToVw('15')};

      svg {
        transform: scale(0.9);
      }
    }

    &.now-fold {
      .category-fold {
        padding-right: ${mixin.pxToVw('60')};

        .swiper {
          padding-right: ${mixin.pxToVw('30')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    position: relative;

    .category-fold {
      &.unFolding {
        .swiper {
          height: auto;
        }

        .swiper-wrapper {
          ${mixin.flex({
            wrap: 'wrap',
            align: 'flex-start',
            justify: 'flex-start',
          })}
          transform: translate3d(0px, 0px, 0px) !important;
          transition-duration: 0ms !important;
        }
      }

      .swiper-wrapper {
        transition-duration: 300ms !important;

        &.noMove {
          transform: translate3d(0px, 0px, 0px) !important;
          transition-duration: 0ms !important;
        }
      }
    }

    .unFolding + .btn-folding {
      svg {
        transform: translateX(0) rotate(180deg);
      }
    }

    ${props => {
      switch (props.type) {
        case 'type1':
          return css`
            .unFolding {
              position: absolute;
              top: 0;
              left: 0;
              width: var(--pc-width);
              padding: 32px 125px 32px 51px;
              border-radius: 14px;
              border: 1px solid #000;
              box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
              background-color: #fff;
              z-index: 1;

              .swiper-wrapper {
                gap: 4px 20px;
              }

              .swiper-slide {
                height: 38px;

                .area-click {
                  margin: 0;
                }
              }
            }

            .btn-folding {
              top: 2px;
              right: 0;
            }

            .unFolding + .btn-folding {
              top: 20px;
              right: 20px;
              width: 24px;
              height: 24px;

              &:after {
                content: '${x}';
                top: -8px;
                right: 0;
                font-size: 35px;
                font-weight: 200;
              }

              svg {
                display: none;
              }
            }

            &.now-fold {
              .category-fold {
                padding-right: 40px;
              }
            }
          `;
        case 'type2':
          return css`
            .category-fold {
              &.unFolding {
                .swiper-wrapper {
                  row-gap: 10px;
                }
              }
            }

            .btn-folding {
              top: 8px;
              right: 8px;

              svg {
                width: 44px;
                height: 44px;
              }
            }
          `;
        case 'type3':
          return css`
            .category-fold {
              &.unFolding {
                .swiper-wrapper {
                  row-gap: 10px;
                }
              }
            }

            .btn-folding {
              top: 0;
              right: 8px;

              svg {
                width: 44px;
                height: 44px;
              }
            }
          `;
        default:
          return null;
      }
    }}
  }
`;
